var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPin = function SvgPin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m2.321 13.679 3.445-3.445m0 0a30.927 30.927 0 0 1-2.862-3.33.336.336 0 0 1 .03-.439 3.027 3.027 0 0 1 2.867-.798c.477.118.972.003 1.244-.441L8.509 2.83a1.066 1.066 0 0 1 1.59-.264 25.307 25.307 0 0 1 3.334 3.334c.415.5.29 1.251-.265 1.59l-2.394 1.464c-.444.272-.559.767-.441 1.244a3.027 3.027 0 0 1-.798 2.866.336.336 0 0 1-.44.031 30.929 30.929 0 0 1-3.329-2.862Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export default ForwardRef;